export default __webpack_public_path__ + "static/blob2-f814fded8e877e659534302d0d333278.svg";